import { render, staticRenderFns } from "./VerfiedWtTooltip.vue?vue&type=template&id=5223a114"
import script from "./VerfiedWtTooltip.vue?vue&type=script&lang=js"
export * from "./VerfiedWtTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports